import MSpinner from "./MSpinner.vue";
export default MSpinner;
export type { MSpinnerProps, MSpinnerSize } from "./MSpinner.props";
